import { Form, useForm } from '@/components/forms';
import { Button } from '@/design-system/button';
import { Translation } from '@/hoslog-intl';
import type { FileObject } from '@/lib/uploadToAWS';
import { uploadFileToS3WithPresignedUrl } from '@/lib/uploadToAWS';
import { PersonalInfo } from '../PersonalInfo';
import { HostFormValues } from '../premium-stores/form/ManageHostManagement';
import { SkillsSet } from '../SkillsSet';
import { SNS } from '../Sns';
import useManageHostInfo from './host-management/hooks/useManageHostInfo';
import { hostFormSchema } from './schema/host-form.schema';
import { buildHostPayload } from './utils/buildHostPayload';

export const ManageHost = ({
  defaultValues,
  hostCodeParam,
}: {
  defaultValues: HostFormValues;
  hostCodeParam: string;
}) => {
  const { mutateAsync } = useManageHostInfo();

  const form = useForm({
    schema: hostFormSchema,
    mode: 'onBlur',
    defaultValues: defaultValues,
  });

  const handleSubmit = async () => {
    const formData = form.getValues();
    let profileImageUrl = '';

    if (typeof formData.profileImage === 'string') {
      profileImageUrl = formData.profileImage;
    } else if (formData.profileImage && typeof formData.profileImage === 'object' && 'file' in formData.profileImage) {
      profileImageUrl = await uploadFileToS3WithPresignedUrl(formData.profileImage as FileObject);
    }

    const payload = buildHostPayload({
      clubId: defaultValues?.clubId || '',
      hostId: defaultValues?.hostId || '',
      hostCode: defaultValues?.hostCode || hostCodeParam || '',
      formData,
      profileImageUrl,
    });
    await mutateAsync(payload);
  };

  return (
    <div className="rounded-lg bg-card shadow-panel p-8">
      <Form form={form} onSubmit={handleSubmit}>
        <PersonalInfo hostDetails={defaultValues} hideField="rank" />
        <SNS storeOrHost="host" />
        <SkillsSet hostDetails={defaultValues} />
        <div className="border-t-2 border-t-muted pt-6 flex flex-row-reverse w-full gap-4 text-sm mt-6 justify-between">
          <Button type="submit" className="w-[110px]">
            <Translation id="common.page.button.submit" />
          </Button>
          <Button type="button" variant="outline" className="w-[122px]" onClick={() => window.history.back()}>
            <Translation id="common.page.button.cancel" />
          </Button>
        </div>
      </Form>
    </div>
  );
};
